import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialRefresh: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M27.43 12.19h1.52v7.62h-1.52Zm-1.52 7.62h1.52v3.05h-1.52Zm0-10.67h1.52v3.05h-1.52Zm1.52-1.52V6.1h1.52V4.57h-7.62v7.62h1.53v-1.52h1.52V9.14h1.53V7.62zm-3.05 15.24h1.53v1.52h-1.53Zm-1.52 1.52h1.52v1.53h-1.52Zm-3.05 1.53h3.05v1.52h-3.05Zm-6.1 1.52h6.1v1.52h-6.1ZM12.19 3.05h6.1v1.52h-6.1ZM9.14 4.57h3.05V6.1H9.14ZM7.62 6.1h1.52v1.52H7.62ZM6.1 7.62h1.52v1.52H6.1ZM4.57 24.38v1.53H3.05v1.52h7.62v-7.62H9.14v1.52H7.62v1.53H6.1v1.52z\"/><path fill=\"currentColor\" d=\"M4.57 19.81H6.1v3.05H4.57Zm0-10.67H6.1v3.05H4.57Zm-1.52 3.05h1.52v7.62H3.05Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialRefresh
